import React from "react";
import { HOME_THEME } from "../../features/home/theme";
import { translations, LanguageCode } from "../../utils/translations";

interface CTASectionProps {
  lang?: LanguageCode;
}

const CTASection: React.FC<CTASectionProps> = ({ lang = "en" }) => {
  const content = translations[lang].automatePage;

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.title}>{content.ctaTitle}</h2>
        <p style={styles.subtitle}>{content.ctaSubtitle}</p>
        <button style={styles.button}>{content.ctaBtn}</button>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "34px 5%",
    background: HOME_THEME.surface,
  },
  container: {
    maxWidth: "1000px",
    margin: "0 auto",
    padding: "32px 5%",
    textAlign: "center" as const,
    borderRadius: "20px",
    background: `linear-gradient(135deg, ${HOME_THEME.primaryDark}, ${HOME_THEME.primary})`,
    color: "#fff",
    boxShadow: "0 30px 60px -25px rgba(1,126,132,0.6)",
  },
  title: {
    margin: "0 0 8px 0",
    fontSize: "1.8rem",
    fontWeight: 900,
  },
  subtitle: {
    margin: "0 auto 18px",
    maxWidth: "560px",
    fontSize: "1rem",
    lineHeight: 1.5,
    opacity: 0.92,
  },
  button: {
    padding: "12px 26px",
    background: "#fff",
    border: "none",
    borderRadius: "10px",
    color: HOME_THEME.primaryDark,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: "0.95rem",
  },
};

export default CTASection;
